import script from "./Language_switch.vue?vue&type=script&setup=true&lang=ts"
export * from "./Language_switch.vue?vue&type=script&setup=true&lang=ts"

import "./Language_switch.vue?vue&type=style&index=0&id=1e5185ed&lang=css"

const __exports__ = script;

export default __exports__